<template>
  <v-card>
    <v-toolbar class="teal white--text">
      <v-toolbar-title>Povolené klíče uživatelů</v-toolbar-title>
      <v-spacer />
      <v-btn icon class="white--text" @click.stop="add">
        <v-icon>add</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>

    <v-dialog v-model="addShown" persistent width="500px" scrollable>
      <v-card>
        <v-toolbar>
          <v-toolbar-title>{{ $t('configuration.certs.addKey.title') }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-select
            :items="items"
            item-text="name"
            item-value="_self"
            v-model="selected"
            :label="$t('configuration.certs.addKey.certificate')"
            autocomplete
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn class="red--text darken-1" flat="flat" @click.native="addShown = false">{{ $t('cancel') }}</v-btn>
          <v-btn class="green--text darken-1" flat="flat" @click.native="save" :loading="isBusy">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <v-list>
        <v-list-tile v-for="item in value.certificates" :key="item._self || item.name">
          <v-list-tile-content>{{ item.name }}</v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon @click="remove(item)"><v-icon>delete</v-icon></v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>

      <div class="text-xs-center my-5" v-if="!value.certificates || value.certificates.length === 0">{{ $t('configuration.certs.noCerts') }}</div>
    </v-card-text>
  </v-card>
</template>

<script>
import UserCertificate from '@/models/UserCertificate'
import Configuration from '@/models/Configuration'

export default {
  props: ['value'],
  data () {
    return {
      items: [],
      selected: null,
      addShown: false,
      isBusy: false
    }
  },
  created () {
    UserCertificate.getList({ include: ['user'] })
      .then(result => {
        this.items = result.items.map(item => {
          item.name = `${item.user.name} ${item.user.surname} - ${item.name}`
          return item
        })
      })

    if (this.value && this.value.certificates) {
      this.value.certificates.forEach(item => {
        item.name = `${item.user.name} ${item.user.surname} - ${item.name}`
      })
    }
  },
  methods: {
    remove (item) {
      let index = this.value.certificates.findIndex(cert => cert._self === item._self)
      if (index >= 0) {
        this.value.certificates.splice(index, 1)
        Configuration.applyRelations(this.value)
          .then(() => {
            this.isBusy = false
          })
          .catch(error => {
            console.error(error)
            alert(this.$t('savingFailed'))
          })
      }
    },
    add () {
      this.addShown = true
    },
    save () {
      let item = this.items.find(item => item._self === this.selected)
      if (item) {
        this.isBusy = true
        this.value.certificates.push(item)
        Configuration.applyRelations(this.value)
          .then(() => {
            this.isBusy = false
            this.addShown = false
            this.selected = null
          })
          .catch(error => {
            console.error(error)
            alert(this.$t('savingFailed'))
          })
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Certificates.vue?2a7f046e